"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceClientGeneratedIDsInQueue = exports.restoreOptimisticResponse = exports.removeOptimisticResponse = exports.addOptimisticResponse = void 0;
var offix_cache_1 = require("offix-cache");
var traverse_1 = __importDefault(require("traverse"));
function addOptimisticResponse(apolloClient, _a) {
    var op = _a.op, qid = _a.qid;
    apolloClient.store.markMutationInit({
        mutationId: qid,
        document: op.mutation,
        variables: op.variables,
        updateQueries: {},
        update: op.update,
        optimisticResponse: op.optimisticResponse
    });
    apolloClient.queryManager.broadcastQueries();
}
exports.addOptimisticResponse = addOptimisticResponse;
function removeOptimisticResponse(apolloClient, _a) {
    var op = _a.op, qid = _a.qid;
    if (op) {
        apolloClient.store.markMutationComplete({
            mutationId: qid,
            optimisticResponse: op.optimisticResponse
        });
        apolloClient.queryManager.broadcastQueries();
    }
}
exports.removeOptimisticResponse = removeOptimisticResponse;
function restoreOptimisticResponse(apolloClient, mutationCacheUpdates, _a) {
    var _b;
    var op = _a.op, qid = _a.qid;
    if (((_b = op === null || op === void 0 ? void 0 : op.context) === null || _b === void 0 ? void 0 : _b.operationName) && mutationCacheUpdates[op.context.operationName]) {
        op.update = mutationCacheUpdates[op.context.operationName];
        addOptimisticResponse(apolloClient, { op: op, qid: qid });
    }
}
exports.restoreOptimisticResponse = restoreOptimisticResponse;
/**
 * Imagine we do a mutation that creates a new object while offline.
 * This object is given a temporary client generated ID.
 * If we do subsequent edits to that object, those edits will also reference the client generated ID.
 * Once the initial mutation to create the object is successful,
 * we need to update all references in the queue to the client generated ID
 * with the actual ID returned from the server.
 */
function replaceClientGeneratedIDsInQueue(queue, operation, result) {
    var op = operation.op;
    var operationName = op.context.operationName;
    var optimisticResponse = op.optimisticResponse;
    if (!optimisticResponse) {
        return;
    }
    var idField = op.context.idField || "id";
    var optimisticId = optimisticResponse[operationName] && optimisticResponse[operationName][idField];
    var resultId = result && result.data && result.data[operationName] && result.data[operationName][idField];
    if (!optimisticId || !resultId) {
        return;
    }
    if (offix_cache_1.isClientGeneratedId(optimisticId)) {
        queue.entries.forEach(function (entry) {
            // replace all instances of the optimistic id in the queue with
            // the new id that came back from the server
            traverse_1.default(entry.operation.op.variables).forEach(function (val) {
                if (this.isLeaf && val && val === optimisticId) {
                    this.update(resultId);
                    queue.updateOperation(entry.operation);
                }
            });
        });
    }
}
exports.replaceClientGeneratedIDsInQueue = replaceClientGeneratedIDsInQueue;
